<app-warehouse-localization-details-form
  (submitClickEvent)="handleSubmitClickEvent($event)"
  [hiddenControls]="['position']" />
